<template>
    <svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
        <rect fill="none" height="256" width="256"/>
        <polyline fill="none" points="108 100 132 84 132 176" stroke="#DD1515" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="24"/>
        <rect fill="none" height="176" rx="8" stroke="#DD1515" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="24" width="176" x="40" y="40"/>
    </svg>
</template>
